<template>
  <!-- if logged in -->
  <div v-if="idToken">
    <h1 class="my-3">Welcome back to the xView 2018 Object Detection Challenge</h1>
     <p>Use the menu (<v-icon>menu</v-icon>) at top left to access data, learn about the Challenge, and interact with the Challenge app. </p>
  </div>

  <!-- If not logged in -->
  <div v-else>
    <h1 class="my-3">Welcome to the xView 2018 Object Detection Challenge</h1>
    <p>If you are visiting for the first time, feel free to browse around. Many resources are publicly accessible via the menu, at top left. To access data and interact with the Challenge app, you will need to create a user account.</p>
    
    <v-btn to='signup' color="primary" dark class="mx-0">Sign up for an account</v-btn>
    
    <v-divider class="my-3"></v-divider>

    <p>If you are a returning user, please sign in:</p> <v-btn to='login' color="primary" dark class="mx-0">Login</v-btn>
    </div>
  </div>
</template>

<script>
  import firebase from 'firebase'

  export default {
    data () {
      return {
        idToken: ''
      }
    },
    mounted () {
      // console.log('Landing page component mounted')
      firebase.auth().currentUser.getIdToken(true)
      .then((idToken) => {
        this.$set(this.$data, 'idToken', idToken)
        // console.log('idToken: ' + idToken)
      })
      // console.log(this.$data)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/LandingPage.vue